<span class="rating-container" [title]="'x-of-y' | translate: { x: rating, y: MAX_RATING }">
  <i *ngFor="let star of ratingArray" class="material-icons">{{ star }}</i>
  <span *ngIf="showExact" class="exact">({{ rating }})</span>
</span>